Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invalidSession = exports.getUserSessionError = exports.getUserSessionSuccess = exports.getSessionError = exports.getSessionSuccess = undefined;

var _actionTypes = require('./actionTypes');

exports.getSessionSuccess = function getSessionSuccess() {
  return { type: _actionTypes.GET_SESSION_SUCCESS };
};

exports.getSessionError = function getSessionError() {
  return { type: _actionTypes.GET_SESSION_ERROR };
};

exports.getUserSessionSuccess = function getUserSessionSuccess(user) {
  return {
    user: user,
    type: _actionTypes.GET_USER_SESSION_SUCCESS
  };
};

exports.getUserSessionError = function getUserSessionError() {
  return { type: _actionTypes.GET_USER_SESSION_ERROR };
};

exports.invalidSession = function invalidSession() {
  return { type: _actionTypes.INVALID_SESSION };
};